import Container from "@components/Atomic/Container/Container";
import { StyledContainer } from "@components/Styled/Container";
import { clsx } from "clsx";
import React from "react";
import { RichTextOutputProps, withRichtext } from "./withRichtext";
import { NestedWrapper } from "../NestedWrapper";

const Wrapper = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, props.padding === "yes" && "py-giga")}
  />
);

const RichtextWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      props.mobileAlignment === "center"
        ? "[&_h1]:text-center [&_h2]:text-center [&_h3]:text-center [&_h4]:text-center [&_h5]:text-center [&_h6]:text-center [&_p]:text-center"
        : "[&_h1]:text-left [&_h2]:text-left [&_h3]:text-left [&_h4]:text-left [&_h5]:text-left [&_h6]:text-left [&_p]:text-left",
      props.desktopAlignment === "center"
        ? "[&_h1]:md:text-center [&_h2]:md:text-center [&_h3]:md:text-center [&_h4]:md:text-center [&_h5]:md:text-center [&_h6]:md:text-center [&_p]:md:text-center"
        : "[&_h1]:md:text-left [&_h2]:md:text-left [&_h3]:md:text-left [&_h4]:md:text-left [&_h5]:md:text-left [&_h6]:md:text-left [&_p]:md:text-left",
    )}
  />
);

const Parent = ({
  children,
  mobileAlignment,
  desktopAlignment,
  width,
  padding,
}: Partial<RichTextOutputProps>) => {
  return (
    <Wrapper width={width} padding={padding}>
      <RichtextWrapper
        mobileAlignment={mobileAlignment}
        desktopAlignment={desktopAlignment}
      >
        {children}
      </RichtextWrapper>
    </Wrapper>
  );
};

const Child = ({ content }: Partial<RichTextOutputProps>) => {
  return <div className="rte">{content}</div>;
};

const Richtext = withRichtext(({ background, styles, nested, ...rest }) => {
  return (
    <Container
      as={nested ? "section" : "div"}
      styles={styles}
      legacy={!styles?.length}
      background={background}
      data-component-type="section-rich-text"
    >
      <NestedWrapper
        {...rest}
        nested={nested}
        renderChild={Child}
        renderParent={Parent}
      />
    </Container>
  );
});

export default Richtext;
